/**
 * Air theme JavaScript.
 */

// Import modules (comment to disable)

import './skip-link-focus-fix';
import MoveTo from 'moveto';
import './sticky-nav.js';
// import slick from 'slick-carousel';
import 'what-input';
import './navigation.js';
import './lazyload.js';
// import './jquery-throttle.js';



// Define Javascript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');




// Init lazyload
// Usage example on template side when air-helper enabled:
// <?php image_lazyload_tag( get_post_thumbnail_id( $post->ID ) ); ?>
let images = document.querySelectorAll('.lazyload');
lazyload(images, {
     root: null,
     rootMargin: "0px",
     threshold: 0
});

function bJqHasEle($something){
  return ($something && $something.length);
}

function addRequiredAttrs(){
  // if(window.console){console.log('addRequiredAttrs()');}
  var $reqFields = jQuery('[aria-required="true"]');
  $reqFields.each(function(){
    jQuery(this).attr('required','required');
  })
}

function createTogglers(){
  // for the few togglers that have to be "manufactured"
  var $contactLink = jQuery('.trigger-contact-us.menu-item > a,a.trigger-contact');
  $contactLink.attr('data-toggle-target','body').attr('data-toggle-classes','modal-form-closed modal-form-open').attr('data-if-open-focus','#input_2_1');
}

function setupTogglers($){
  let debug = false;
  if(debug && window.console){
    console.log('setupTogglers()');
  }
  createTogglers();

  var $togglers = $('[data-toggle-target][data-toggle-classes]');
  $togglers.each(function(){
    var $toggler = $(this);
    var $target = $($toggler.attr('data-toggle-target'));
    var sClasses = $toggler.attr('data-toggle-classes');
    $toggler.on('click',function(e){
      if(debug && window.console){
        console.log('toggler clicked',$toggler);
      }
      e.preventDefault();
        if($target && $target.length){
          $target.toggleClass(sClasses);
        }
        if($toggler.is('[data-toggle-self-classes]')){
          var sSelfClasses = $toggler.attr('data-toggle-self-classes');
          $toggler.toggleClass(sSelfClasses);
        }
        if($toggler.is('[data-if-open-focus]')){
          if(debug && window.console){
            console.log('focuser');
          }
          var sFocusSelector = $toggler.attr('data-if-open-focus');
          var $focusTarget = $(sFocusSelector);
          // console.log('$focusTarget',$focusTarget);
          if($target.is(':visible') && $focusTarget && $focusTarget.length && $focusTarget.is(':visible')){
            $focusTarget.focus();
            if(debug && window.console){
              console.log('focused on $focusTarget',$focusTarget)
            }
          } else {
              if(debug && window.console){
              console.log('A');
            }
            if($target.is(':visible') && bJqHasEle($focusTarget) && !$focusTarget.is(':visible')){
              var $firstVisibleField = $focusTarget.closest('div:visible').find('input:visible').first();
              if(debug && window.console){
                console.log('B');
              }
              if(bJqHasEle($firstVisibleField)){
                if(debug && window.console){
                  console.log('C');
                }
                $firstVisibleField.focus();
                if(debug && window.console){
                  console.log('focused on first visible input',$firstVisibleField);
                }
              }
            }
          }
        }
    });
  });

  var $ancestorToggler = $('[data-toggle-target-closest][data-toggle-classes]');
  $ancestorToggler.each(function(){
    var $toggler = $(this);
    var $target = $toggler.closest($toggler.attr('data-toggle-target-closest'));
    var sClasses = $toggler.attr('data-toggle-classes');
    $toggler.on('click',function(e){
      e.preventDefault();
        if($target && $target.length){
          $target.toggleClass(sClasses);
        }
        if($toggler.is('[data-toggle-self-classes]')){
          var sSelfClasses = $toggler.attr('data-toggle-self-classes');
          $toggler.toggleClass(sSelfClasses);
        }
        if($toggler.is('[data-if-open-focus]')){
          // console.log('focuser');
          var sFocusSelector = $toggler.attr('data-if-open-focus');
          var $focusTarget = $(sFocusSelector);
          // console.log('$focusTarget',$focusTarget);
          if($target.is(':visible') && $focusTarget && $focusTarget.length){
              $focusTarget.focus();
          }
        }
    });
  });
}

function setupBackToTop(){
    // Set up back to top link
    var moveTo = new MoveTo();
    var target = document.getElementById('target');
    moveTo.move(target);

    // Register a back to top trigger
    var trigger = document.getElementsByClassName('js-trigger')[0];
    moveTo.registerTrigger(trigger);
}

function setupEqualizeMaxH(){
  // if(window.console){console.log('setupEqualizeMaxH()')}
  var $groups = jQuery('[data-equalize-max-h-to-select]')
  var maxHeight = -1;
  $groups.each(function(){
    var $g = jQuery(this);
    var sTargetsSelector = $g.attr('data-equalize-max-h-to-select');
    var $gTargets = jQuery(sTargetsSelector);
    $gTargets.each(function() {
      var $gTarget = jQuery(this);
      if($gTarget.is('[style]')){$gTarget.removeAttr('style')}
      maxHeight = maxHeight > $gTarget.outerHeight() ? maxHeight : $gTarget.outerHeight();
     });
    console.log('maxHeight',maxHeight);
    $gTargets.css('max-height',maxHeight);
  });
}

function setupEqualizeH(){
  // if(window.console){console.log('setupEqualizeH()')}
  var $groups = jQuery('[data-equalize-h-to-select]')
  var maxHeight = -1;
  $groups.each(function(){
    var $g = jQuery(this);
    var sTargetsSelector = $g.attr('data-equalize-h-to-select');
    var $gTargets = jQuery(sTargetsSelector);
    $gTargets.each(function() {
      var $gTarget = jQuery(this);
      if($gTarget.is('[style]')){$gTarget.removeAttr('style')}
      maxHeight = maxHeight > $gTarget.outerHeight() ? maxHeight : $gTarget.outerHeight();
     });
    // console.log('height',maxHeight);
    $gTargets.css('height',maxHeight);
    $gTargets.css('max-height',maxHeight);
  });
}

function onloadStuff(){
  if(window.console){console.log('load');}
  setupEqualizeMaxH();
  setupEqualizeH();
}

function onresizeStuff(){
  if(window.console){console.log('throttled resize');}
  setupEqualizeMaxH();
  setupEqualizeH();
}

var resizeId;
function setupOnresizer(){
  // jQuery(window).resize( jQuery.debounce( 250, onresizeStuff) );
  window.addEventListener('resize', function() {
    clearTimeout(resizeId);
    resizeId = setTimeout(onresizeStuff, 300);
  });
}

// dollaFormatter.format(1000) // "$1,000.00"
const dollaFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});

function currencyToFloat(sInput){
  return Number(sInput.replace(/[^0-9.-]+/g,""));
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function recalcForm($f){
  let debug = false;
  if(debug && window.console){
    console.log('recalcForm() $f',$f);
  }
  $f.find('.suffix').text(numberWithCommas($f.find('input[name="annualhours"]').val()));
  var nHpOut = parseInt($f.find('input[name="hpoutput"]').val());
  var nAnnualHours = parseFloat($f.find('input[name="annualhours"]').val());
  var mbhinputperhr = nHpOut * 33475 * 1.25 / 1000000;
  $f.find('.mbhinput').text(mbhinputperhr.toFixed(2));

  var ofc = 0.6 * 1.26 * (nHpOut * nAnnualHours * 41840) / 100000;
  $f.find('.output-fuel-cost').text(dollaFormatter.format(ofc));

  var ms1 = ofc * 0.039;
  $f.find('.min-savings-1').text(dollaFormatter.format(ms1));

  var ms2 = ofc * 0.03;
  $f.find('.min-savings-2').text(dollaFormatter.format(ms2));

  var ms3 = ofc * 0.02;
  $f.find('.min-savings-3').text(dollaFormatter.format(ms3));

  var nMbhinput = parseFloat($f.find('.mbhinput').text());
  var nAnnualAdjustmentMaint = parseFloat(currencyToFloat($f.find('.min-savings-4').text()));

  var total = ms1 + ms2 + ms3 + nAnnualAdjustmentMaint;
  $f.find('.yearly-total-savings').text(dollaFormatter.format(total));

  var nAverageConvertCost = currencyToFloat($f.find('.average-cost-per-boiler').text());

  var nPaybackYears = total / nAverageConvertCost;
  $f.find('.payback-years').text(nPaybackYears.toFixed(2));


  if(debug && window.console){
    console.log('total',total);
    console.log('nAverageConvertCost',nAverageConvertCost);
    console.log('nPaybackYears',nPaybackYears);
  }

}

function setupCalc(){
  let debug = false;
  if(debug && window.console){
    console.log('setupCalc()');
  }
  var $f = jQuery('.calculator-form');
  if(bJqHasEle($f)){
    var $editableFields = $f.find('input,select');
    $editableFields.on('keydown keypress change',function(){
      recalcForm($f);
    });
    $editableFields.first().trigger('change');
  }
}

function setupClampedContent(){
  jQuery('.product-type .description').succinct2({
    size: 276,
    restorable: true
  });
}

function setupHideSelfShowNexts(){
  var $hideSelfShowNexts = jQuery('[data-click-2-hide-this-show-next="true"]');
  $hideSelfShowNexts.each(function(){
    var $trigger = jQuery(this);
    var $target = $trigger.next();
    $trigger.on('click',function(){
      $trigger.hide();
      $target.show();
    });
  });

}

function updateGateStatus(){
  let debug = false;
  if(debug && window.console){
    console.log('updateGateStatus()');
  }
  var bShared = jQuery.cookie('email-shared') && jQuery.cookie('email-shared')==='true';
  if(debug && window.console){
    console.log('bShared',bShared);
  }
  // check to see if gate should be open and open it
  if(bShared){
    jQuery('.modal-calc').removeClass('gate-closed').addClass('gate-open');
  }
}

function setupGate(){
  let debug = false;
  var $gateForm = jQuery('form.gate-form');

  if(debug && window.console){
    console.log('setupGate()');
  }
  updateGateStatus();

  // add logic for sending the email back to server to save
  $gateForm.on('submit',function(event){
    event.preventDefault();
    if(debug && window.console){
      console.log('SUBMITTING GATE');
    }
    var $gateField = jQuery('#gate-email-address');
    var sReturnFromPrefix = "/wp-json/trojan/v1/e/";
    var sReturnFrom = sReturnFromPrefix + '?e='+encodeURIComponent($gateField.val());
    var getLink = jQuery.ajax({url: sReturnFrom}).done(function(data){
      if(debug && window.console){
        console.log('SERVER RESPONSE:',data);
      }
      if(data && data !== 'Naa' && data!== 'Sorry'){
        jQuery.cookie('email-shared', 'true', { expires: 1, path: '/' });
        updateGateStatus();
      }
    });
    // if saves ok then show calc
    // $.cookie('email-shared', 'true', { expires: 1, path: '/' });
  });
}

function formFix(){
  // A change in Gravity Forms has changed its markup breaking some styles. This updates the DOM to match the original GF DOM
  var $gfContactDesc = jQuery('#gform_wrapper_2 .gform_heading');
  if($gfContactDesc && $gfContactDesc.length){
    var $f = jQuery('#gform_2');
    if($f && $f.length){
      $f.prepend($gfContactDesc);
    }
  }
}

// jQuery start
( function( $ ) {

  // Based on Mike King (@micjamking) Succinct https://github.com/micjamking/Succinct Licensed under the MIT License
  $.fn.succinct2 = function(options) {

    var settings = $.extend({
        size: 240,
        omission: '...',
        ignore: true,
        restorable: false
      }, options);

    return this.each(function() {

      var textDefault,
        textTruncated,
        elements = $(this),
        regex    = /[!-\/:-@\[-`{-~]$/,
        init     = function() {
          elements.each(function() {
            textDefault = $(this).html();
            if(settings.restorable){
              $(this).empty().addClass('clamp-able clamp-on').prepend('<div class="full-text">'+textDefault+'</div>');
            }

            if (textDefault.length > settings.size) {
              textTruncated = $.trim(textDefault)
                      .substring(0, settings.size)
                      .split(' ')
                      .slice(0, -1)
                      .join(' ');

              if (settings.ignore) {
                textTruncated = textTruncated.replace(regex, '');
              }

              if(settings.restorable){
                settings.omission = '... <span class="control restore" data-toggle-target-closest=".description" data-toggle-classes="clamp-on clamp-off">Read more</span>';
                $(this).append('<div class="clamped-text">'+textTruncated + settings.omission+'</div>');
              } else {
                $(this).html(textTruncated + settings.omission);
              }

            }
          });
        };
      init();
    });
  };

  /*! jquery.cookie v1.4.1 | MIT */
  !function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?a(require("jquery")):a(jQuery)}(function(a){function b(a){return h.raw?a:encodeURIComponent(a)}function c(a){return h.raw?a:decodeURIComponent(a)}function d(a){return b(h.json?JSON.stringify(a):String(a))}function e(a){0===a.indexOf('"')&&(a=a.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return a=decodeURIComponent(a.replace(g," ")),h.json?JSON.parse(a):a}catch(b){}}function f(b,c){var d=h.raw?b:e(b);return a.isFunction(c)?c(d):d}var g=/\+/g,h=a.cookie=function(e,g,i){if(void 0!==g&&!a.isFunction(g)){if(i=a.extend({},h.defaults,i),"number"==typeof i.expires){var j=i.expires,k=i.expires=new Date;k.setTime(+k+864e5*j)}return document.cookie=[b(e),"=",d(g),i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}for(var l=e?void 0:{},m=document.cookie?document.cookie.split("; "):[],n=0,o=m.length;o>n;n++){var p=m[n].split("="),q=c(p.shift()),r=p.join("=");if(e&&e===q){l=f(r,g);break}e||void 0===(r=f(r))||(l[q]=r)}return l};h.defaults={},a.removeCookie=function(b,c){return void 0===a.cookie(b)?!1:(a.cookie(b,"",a.extend({},c,{expires:-1})),!a.cookie(b))}});

	// Hide or show the "back to top" link
	$(window).scroll(function() {

    // Back to top
  	var offset = 300; // Browser window scroll (in pixels) after which the "back to top" link is shown
  	var offset_opacity = 1200; // Browser window scroll (in pixels) after which the link opacity is reduced
  	var scroll_top_duration = 700; // Duration of the top scrolling animation (in ms)
    var link_class = '.top';

		if( $(this).scrollTop() > offset ) {
      $( link_class ).addClass('is-visible');
    } else {
      $( link_class ).removeClass('is-visible');
    }

		if( $(this).scrollTop() > offset_opacity ) {
			$( link_class ).addClass('fade-out');
		} else {
      $( link_class ).removeClass('fade-out');
    }

	});
  onload = onloadStuff;

  // Document ready start
  $(function() {
    if(window.console){console.log('ready');}
    setupClampedContent();
    setupBackToTop();
    setupTogglers($)
    addRequiredAttrs();
    formFix();
    setupOnresizer();
    setupGate();
    setupCalc();
    setupHideSelfShowNexts();

  });

} )( jQuery );
